import { ReactNode } from 'react';

import Component from './component';

export interface Props {
    children?: any;
    type?: ButtonTypes;
    element?: ButtonElements;
    className?: string;
    onClick?: Function;
    href?: string;
    icon?: {
        type: ButtonIconTypes;
        value: any;
        position: ButtonIconPositions;
        width?: number | string;
        height?: number | string;
    };
    disabled?: boolean;
    size?: ButtonSizes;
    style?: ButtonStyles;
    styles?: object;
    variant?: ButtonVariants;
    layout?: ButtonLayouts;
    tooltipText?: string;
    loading?: boolean;
    confirm?: {
        enabled: boolean;
        message?: string;
    };
    copy?: {
        enabled: boolean;
        content: string;
    }
    buttonProps?: any;
    shadow?: {
        enabled: boolean;
        style?: object;
    };
    label?: string;
    callLabel?: string;
    tooltip?: {
        key: string;
        text: ReactNode | string;
        visible?: boolean;
    }
}

export enum ButtonTypes {
    Button = 'button',
    Submit = 'submit',
}

export enum ButtonElements {
    Button = 'button',
    Anchor = 'anchor',
}

export enum ButtonStyles {
    Primary = 'primary',
    Secondary = 'secondary',
    Light = 'light',
    Gold = 'gold',
    Green = 'green',
    None = 'none',
    White = 'white',
}

export enum ButtonVariants {
    Primary = 'primary',
    Outline = 'outline',
    Underline = 'underline',
}

export enum ButtonLayouts {
    Default = 'default',
    Wide = 'wide',
    Block = 'block',
}

export enum ButtonSizes {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum ButtonIconTypes {
    Image = 'image',
    Element = 'element',
}

export enum ButtonIconPositions {
    Before = 'before',
    After = 'after',
}

export interface ListProps extends Props {
    key: string;
}

Component.defaultProps = {
    element: ButtonElements.Button,
    style: ButtonStyles.Gold,
    styles: {},
    variant: ButtonVariants.Primary,
    size: ButtonSizes.Medium,
    layout: ButtonLayouts.Wide,
    className: '',
    onClick: null,
    type: ButtonTypes.Button,
    disabled: false,
    loading: false,
    confirm: null,
    copy: null,
    href: null,
    buttonProps: {},
    shadow: null,
    icon: null,
    label: null,
    tooltip: null,
};

export default Component;
